<template>
    <v-dialog
        v-model="dialog"
        max-width="600"
    >
        <v-card>
            <v-card-title class="headline">
                Manually opt in or out
            </v-card-title>

            <v-card-text>
                <m-autocomplete-phone-number
                    label="Name or phone number(s)"
                    autofocus
                    :organization_id="organization_id"
                    :set_from_endpoint_value="endpoint_value"
                    v-on:input="setEndpointValue"
                />

                <v-select
                    label="Opt Out State"
                    :items="opt_choices"
                    v-model="opt_in_status"
                />

                <div
                    v-if="opt_in_status == 'grant'"
                >
                    <b style="color: red">Warning</b>: You should only manually opt someone in unusual circumstances where you have obtained their written consent offline.  
                    Best practice is to send the customer an opt in message (click <b>(+)</b> and choose "<b>Send Opt In Message</b>")

                </div>

                <v-textarea
                    label="Notes"
                    v-model="notes"
                    rows="1"
                    auto-grow
                    hint="Additional information about setting this customer's status"
                />

                <v-checkbox
                    label="Conversational"
                    v-model="conversational"
                    style="margin-bottom: -25px"
                />

                <v-checkbox
                    label="Informational"
                    v-model="informational"
                    style="margin-bottom: -25px"
                />

                <v-checkbox
                    label="Promotional"
                    v-model="promotional"
                    style="margin-bottom: -25px"
                />

                
                <m-legal-checkbox-agreement
                        type="manual-opt-in-number-attestation"
                        :organization_id="$rc.$state.getOrganizationId()"
                        v-model="consent_acknowledgement"
                        ref="consent_acknowledgement"
                        style="margin-right: 15px; margin-bottom: 15px; margin-top: 15px;"
                        v-if="opt_in_status == 'grant'"
                    />

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    text
                    @click="dialog = false;"
                >
                    Cancel
                </v-btn>

                <v-btn
                    color="primary darken-1"
                    text
                    @click="onOk"
                    :disabled="!is_valid"
                >
                    Ok
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            organization_id: null,
            opt_in_status: 'deny',
            notes: '',
            endpoint_value: null,
            conversational: true,
            informational: true,
            promotional: true,

            consent_acknowledgement: false,

            dialog: false,

            full_name: null,

            opt_choices:[
                { 'text' : 'Opt In', 'value' : 'grant' },
                { 'text' : 'Opt Out', 'value' : 'deny' },
            ],
        }
    },

    methods: {
        showDialog(organization_id, endpoint, full_name)
        {
            this.organization_id = organization_id;
            this.dialog = true;
            this.notes = '';
            this.opt_in_status = 'deny';

            this.conversational = true;
            this.informational = true;
            this.promotional = true;
            this.full_name = full_name;
            this.consent_acknowledgement = false;

            if ( endpoint )
            {
                this.endpoint_value = endpoint;
            }
            else
            {
                this.endpoint_value = null;
                return;
            }
        },

        setEndpointValue(new_endpoint)
        {
            if ( !new_endpoint )
            {
                this.$rc.alert(
                    'Error Select Number',
                    'There was an error selecting the phone number. Please try again.'
                );

                return;
            }

            this.endpoint_value = new_endpoint.value;
        },


        onOk() {
            this.dialog = false;

            let specimen = null;

            if ( this.opt_in_status == 'grant' && this.$refs['consent_acknowledgement'] != null )
                specimen = this.$refs['consent_acknowledgement'].getSpecimen();

            let params = {
                'organization_id' : this.organization_id,
                'endpoint' : this.endpoint_value,
                'state' : this.opt_in_status,
                'memo' : this.notes,
                'categories' : [],
                'full_name': this.full_name,
                'affirmation_specimen': specimen,
            };

            if ( this.conversational ) params.categories.push('conversational');
            if ( this.informational ) params.categories.push('informational');
            if ( this.promotional ) params.categories.push('promotional');

            this.$rc.showSpinner();

             
            this.$rc.rest(
                'PUT: /api/v1/consent/manual',
            
                params,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$emit('upsert_bulk_opt_out');
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to update consent status');
                },
            );
        },
    },


    computed: {
        is_valid() {

            if ( this.endpoint_value == null || this.opt_in_status == null ) return false;
            if ( this.conversational == false && this.informational == false && this.promotional == false ) return false;

            if ( this.opt_in_status == 'grant' && this.consent_acknowledgement == false ) return false;

            return true;
        }
    },
}
</script>